import {
  FilterMode,
  AlertRuleCreateMutationVariables,
  AlertRule_OrderBy,
  AlertRule,
  SortOrder,
  AlertRule_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const alertRuleService = {
  createOne: buildCreateOne(
    (alertRuleCreateVariables: AlertRuleCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.alertRuleCreate(alertRuleCreateVariables);
        return result.alertRuleCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.alertRuleOne({ id });
    return result.alertRuleOne as AlertRule;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AlertRule_OrderBy[] | null = null,
    filter: AlertRule_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AlertRule_Filter | undefined;
    if (searchValue !== "") {
      where = {
        alertType: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.alertRuleListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ alertType: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.alertRuleListWithOffset
    ) as AlertRule[];
    return { list, orderBy };
  },
};
